// URLs
export const DEFAULT_STARGATE_SERVICE_URL = '/gateway/api';
export const DIRECT_ACCESS_URL = '/invitations/v1/settings/domain-enabled-signup-promotion';
export const PERMS_URL = '/permissions/permitted';
